import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListViewHistory = async (param) => {
  let url = `${API_URL.Loader}/api/TextLoader/GetListViewHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetViewUpload = async (param) => {
  let url = `${API_URL.Loader}/api/TextLoader/GetViewUpload`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


